module.exports = __webpack_public_path__ + "static/media/Shame.e3b5d48f.jpg";